import React from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './matchSheetRoundData.scss';
import { getPointToDisplayTriangle } from '../../../../utils/matchScorePrintPage';
import Triangle from '../../Triangle';

const Round = (props) => {
    const { pointsToWin, round, totalRounds, match } = props;

    const section1Points = Array(pointsToWin + 1).fill(null).map((_, index) => index);
    const section2Points = Array(2).fill(null).map((_, index) => index + 1);
    const section3Points = Array(4).fill(null).map((_, index) => index + 1);

    const isFirstRound = round === 1;
    const isLastRound = round === totalRounds;
    const pointToDisplayTriangle = getPointToDisplayTriangle(match.matchScoringTypeId);

    return (
        <div className={`${styles.round} ${isFirstRound ? styles.topBorder : ''}`}>
            <div className={styles.section}>
                {isFirstRound && (
                    <div className={styles.title}>
                        Server
                    </div>
                )}
                <div className={styles.details}>
                    <div className={styles.emptySection}>
                        &nbsp;
                    </div>
                    <div className={styles.pointsSection}>
                        {section1Points.map((point) => {
                            return (
                                <div key={`section-1-point-${point}`} className={styles.point}>
                                    {point}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {isLastRound && pointToDisplayTriangle > 0 && (
                    <div className={`${styles.details} ${styles.triangleSection}`}>
                        <div className={styles.emptySection} />
                        <div className={styles.pointsSection}>
                            {section1Points.map((point) => {
                                return (
                                    <div key={`triangle-section-1-point-${point}`} className={styles.point}>
                                        {point === pointToDisplayTriangle && <Triangle />}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.section}>
                {isFirstRound && (
                    <div className={`${styles.title} text-center`}>
                        T/O
                    </div>
                )}
                <div className={styles.details}>
                    <div className={styles.pointsSection}>
                        {section2Points.map((point) => {
                            return (
                                <div
                                    key={`section-2-point-${point}`}
                                    className={`${styles.point} ${styles.solidBorder}`}
                                >
                                    &nbsp;
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className={styles.section}>
                {isFirstRound && (
                    <div className={`${styles.title} text-center`}>
                        VW / TW / TF
                    </div>
                )}
                <div className={styles.details}>
                    {isFirstRound && (
                        <div className={styles.pointsSection}>
                            {section3Points.map((point) => {
                                return (
                                    <div
                                        key={`section-3-point-${point}`}
                                        className={`${styles.point} ${styles.solidBorder}`}
                                    >
                                        &nbsp;
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

Round.propTypes = {
    pointsToWin: PropTypes.number,
    round: PropTypes.number.isRequired,
    totalRounds: PropTypes.number.isRequired,
    match: PropTypes.objectOf(any).isRequired,
};

Round.defaultProps = {
    pointsToWin: 21,
};

export default Round;
